import { useParams } from 'react-router-dom';
import SEO from '@/components/SEO';
import GridBackground from '@/components/GridBackground';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloatButton from '@/components/WhatsAppFloatButton';
import Breadcrumbs from '@/components/Breadcrumbs';
import ServiceDetailBody from '@/components/services/ServiceDetailBody';
import ServiceDetailExtras from '@/components/services/ServiceDetailExtras';
import ServicesCTA from '@/components/services/ServicesCTA';
import PageNotFound from '@/lib/PageNotFound';
import { SERVICE_KEYS, AE_SERVICE_PATHS, serviceAlternates } from '@/lib/locales';
import { servicePages } from '@/components/services/servicePages';
import { services } from '@/components/services/servicesData';
import { SITE_URL, ORG_REF, breadcrumbLd, faqLd } from '@/lib/structuredData';

export default function ServiceDetail({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const page = servicePages.find((p) => p.slug === slug);
  if (!page) return <PageNotFound />;

  const service = services[page.serviceIndex];
  const path = `/services/${page.slug}`;
  const aeKey = SERVICE_KEYS.find((k) => AE_SERVICE_PATHS[k] === path);
  const crumbs = [{ label: 'Home', to: '/' }, { label: 'Services', to: '/services' }, { label: page.name, to: path }];

  return (
    <div className="min-h-screen bg-background text-foreground relative">
      <SEO
        fullTitle={page.title}
        description={page.meta}
        path={path}
        alternates={aeKey ? serviceAlternates(aeKey) : []}
        structuredData={{
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'Service',
              name: page.h1,
              serviceType: page.name,
              description: page.meta,
              url: `${SITE_URL}${path}`,
              provider: ORG_REF,
              areaServed: [{ '@type': 'City', name: 'Dubai' }, { '@type': 'Country', name: 'United Arab Emirates' }]
            },
            breadcrumbLd(crumbs),
            faqLd(page.faqs)
          ]
        }}
      />
      <GridBackground />
      <Navbar />
      <main className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 pt-36 pb-12">
        <Breadcrumbs items={crumbs} />
        <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-4 block">{service.tag}</span>
        <h1 className="font-inter font-black text-5xl md:text-7xl tracking-[-0.03em] text-foreground mb-6 leading-[1.05]">{page.h1}</h1>
        <p className="text-lg text-muted-foreground font-inter leading-relaxed mb-16">{page.intro}</p>
        <ServiceDetailBody page={page} />
        <ServiceDetailExtras page={page} />
      </main>
      <ServicesCTA message={service.waMessage} />
      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}